import { Notice } from "@applyboard/crystal-ui"
import { ConfidenceLevel, DocumentProcessStatus } from "../../../../hooks/useGetPassport"
import { includes } from "lodash"

type WarningsProps = Readonly<{
  documentProcessStatus?: DocumentProcessStatus
  documentTypeConfidence?: ConfidenceLevel
  hasAiProcessingTimedOut?: boolean
  onClick: () => void
}>

export function Warnings(props: Readonly<WarningsProps>) {
  if (
    props.documentProcessStatus === DocumentProcessStatus.DOCUMENT_DATA_EXTRACTION_COMPLETED &&
    props.documentTypeConfidence === ConfidenceLevel.HIGH
  ) {
    return (
      <Notice intent="positive">
        Success! The passport has been uploaded.<br/>
        We’ve pre-filled the application with the following information. Please review it and make any necessary changes.
        <Notice.CloseButton onClick={props.onClick} />
      </Notice>
    )
  }

  if (
    props.documentProcessStatus === DocumentProcessStatus.DOCUMENT_DATA_EXTRACTION_COMPLETED &&
    props.documentTypeConfidence === ConfidenceLevel.LOW
  ) {
    return (
      <Notice intent="warning">
        Some fields couldn't be extracted automatically. Please review and enter the missing
        information.
        <Notice.CloseButton onClick={props.onClick} />
      </Notice>
    )
  }

  if (props.hasAiProcessingTimedOut) {
    return (
      <Notice intent="warning">
        Processing took longer than expected. To keep things moving, please enter the information manually.
        <Notice.CloseButton onClick={props.onClick} />
      </Notice>
    )
  }

  if (props.documentProcessStatus === DocumentProcessStatus.UPLOADED_AI_SERVICE_UNAVAILABLE) {
    return (
      <Notice intent="warning">
        Extraction is temporarily unavailable. Please enter the information manually.
        <Notice.CloseButton onClick={props.onClick} />
      </Notice>
    )
  }

  if (
    includes(
      [
        DocumentProcessStatus.DOCUMENT_TYPE_VALIDATION_FAILED,
        DocumentProcessStatus.DOCUMENT_DATA_EXTRACTION_FAILED,
      ],
      props.documentProcessStatus,
    ) ||
    (props.documentProcessStatus === DocumentProcessStatus.DOCUMENT_DATA_EXTRACTION_COMPLETED &&
      props.documentTypeConfidence === ConfidenceLevel.MISMATCH)
  ) {
    return (
      <Notice intent="warning">
        Please consider uploading the document again. The document classification does not match the
        expected type or may be of poor quality.
        <Notice.CloseButton onClick={props.onClick} />
      </Notice>
    )
  }

  return null
}
